<template>
  <div class="find-password" :style="{ height: windowHeight + 'px' }">
    <headerBar title="找回密码"></headerBar>
    <div class="form">
      <div class="form-input"><input type="text" placeholder="请输入手机号" v-model="mobile" /></div>
      <div class="form-input">
        <input type="text" placeholder="请输入验证码" v-model="checkcode" />
        <button :disabled="codeDisable" @click="getNumCode">{{ codetitle }}</button>
      </div>
      <div class="form-input"><input type="password" v-model="password" placeholder="请输入新密码" /></div>
      <div class="form-input"><input type="password" v-model="repassword" placeholder="请再次输入密码" /></div>
    </div>
    <button class="submit" @click="submit" :disabled="btnState">提交</button>

    <!--解决浏览器自动填充密码的问题-->
    <input type="password" autoComplete="new-password" hidden />
  </div>
</template>

<script>
import { Toast } from 'mint-ui';
export default {
  data() {
    return {
      windowHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
      repassword: '',
      password: '',
      btnState: false, //防重复点击
      checkcode: '', //验证码
      mobile: '',
      codeDisable: false, //防止重复获取验证码
      codetitle: '获取验证码'
    };
  },
  onShow() {},
  methods: {
    //提交修改
    submit() {
      if (!this.mobile) {
        Toast('请填写手机号');
        return false;
      }
      if (!this.checkcode) {
        Toast('请填写验证码');
        return false;
      }
      if (!this.password) {
        Toast('请填写新密码');
        return false;
      }
      if (!this.repassword) {
        Toast('请填写密码再次确认');
        return false;
      }
      if (this.repassword && this.password && this.repassword != this.password) {
        Toast('两次密码填写不一致请重新填写');
        return false;
      }
      this.btnState = true;

      let data = {
        mobile: this.mobile,
        checkcode: this.checkcode,
        password: this.password,
        repassword: this.repassword
      };

      this.$request.post('/front/Login/resetPassword', data, res => {
        console.log(res);
        if (res.status == 1) {
          Toast(res.msg);
          setTimeout(() => {
            this.$router.go(-1);
          }, 1500);
        } else {
          Toast(res.msg);
        }
        this.btnState = false;
      });
    },
    /**
     * 获取验证码
     * */
    getNumCode() {
      if (this.mobile) {
        let reg = /^[1][3-9]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$|^\d{10}$/;
        if (!reg.test(this.mobile)) {
          Toast('请输入正确的手机号');
        } else {
          //防重复点击
          if (this.codeDisable == false) {
            this.codeDisable = true;
            this.timeCount();
            let data = {
              mobile: this.mobile,
              type: 2 //type:0注册,type:1登录,type:2密码找回,type:3身份认证
            };
            this.$request.post('/front/Sundries/send', data, res => {});
          }
        }
      } else {
        Toast('请输入正确的手机号');
      }
    },

    /**
     * 验证码读秒
     */
    timeCount() {
      let num = 60;
      clearInterval(timer);
      let timer = setInterval(() => {
        num -= 1;
        this.codetitle = num + 's 重新获取';
        if (num < 0) {
          clearInterval(timer);
          this.codeDisable = false; //启用点击
          this.codetitle = '获取验证码';
        }
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
.find-password {
  width: 100%;
  padding: 0.4rem;
  padding-top: 2rem;
  box-sizing: border-box;
  background: white;
}
.login-title{
  font-size: 0.45rem;
  position: relative;
  padding-top: 1.5rem;
  padding-bottom: 0.5rem;
  text-align: center;
  .goback{
    width: 0.2rem;
    position: absolute;
    top: 0.2rem;
    left: 0rem;
  }
}
.form-input {
  width: 100%;
  height: 1.1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #cccccc;
  position: relative;
}
.form-input input {
  width: 100%;
  height: 0.5rem;
  line-height: 0.5rem;
}
.form-input button {
  width: 2rem;
  height: 0.6rem;
  line-height: 0.6rem;
  border-radius: 0.3rem;
  border: 1px solid #00b378;
  font-size: 0.26rem;
  color: #8cf3d1;
  position: absolute;
  top: 50%;
  right: 0.2rem;
  transform: translateY(-50%);
}

.submit {
  margin-top: 1rem;
  width: 100%;
  height: 0.8rem;
  line-height: 0.8rem;
  text-align: center;
  background: #00b378;
  color: white;
  border-radius: 0.4rem;
  font-size: 0.32rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/findPassword.vue